import Axios from 'axios'

import { TMetricDataPostBody, TPublicMetric } from 'types/GlobalMetric'
import { TGlobalFilterApiInput } from 'types/GlobalGlobalFilter'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/metrics`

export async function fetchData(
  id: string,
  globalFilter: TGlobalFilterApiInput,
  body: TMetricDataPostBody
) {
  return Axios.post(
    `${URL}/${id}`,
    {
      data: {
        ...body,
        query_params: {
          ...(body.query_params || {}),
          global_filter: globalFilter
        }
      }
    },
    parseAuthenticationHeader()
  )
}

// Tokenless fetch for the public metric preview page. The empty config keeps
// authentication headers out of the request.
export async function getOnePublic(id: string) {
  return getWithRedirect<TPublicMetric>(`${BASE_URL}v1/public/metrics/${id}`, {})
}
